import { createContext } from 'react';

/**
 * How a screen under the app's layout opens work-area creation: the same dialog the sidebar's
 * *New work area* opens, provided by `Layout`. `null` outside it, where the empty state offers no
 * action rather than one that does nothing.
 *
 * Its own module, so `Layout` provides it without importing `NoWorkAreaEmptyState`, whose
 * `allWorkAreas` words load with the screens that draw it and not with the launch entry.
 */
export interface ICreateWorkAreaAction {
  open: () => void;
  /** Why creating is refused for this session, said on the button instead of leaving it dead. */
  disabledReason: string | null;
}

export const CreateWorkAreaActionContext = createContext<ICreateWorkAreaAction | null>(null);
